import {$} from './jquery-definition.js';

$( window ).load( function() {
	var $recaptchaResponse = $( '.g-recaptcha-response' );

	$recaptchaResponse.each( function( index ) {
		var $this = $( this );
		var labelFor = 'g-recaptcha-response';

		if ( index > 0 ) {
			labelFor += '-' + index;
		}

		$( '<label for="' + labelFor + '"><span class="screen-reader-text">Do not use</span></label>' ).insertAfter( $this );
	} );
} );
